// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A1nYw","input":"styles_input__2mcvK"};